/**
 * Client-side analytics singleton (for use outside React components)
 *
 * Use `useAnalytics()` hook in React components.
 * Use `getClientAnalytics()` in mutation hooks and other non-component code.
 */

import type { AnalyticsClient } from './types';
import { noopAnalyticsClient } from './noop-provider';

let registeredClient: AnalyticsClient = noopAnalyticsClient;

export const setClientAnalyticsClient = (client: AnalyticsClient): void => {
	registeredClient = client;
};

export const getClientAnalytics = (): AnalyticsClient => {
	return registeredClient;
};
